<template>
  <div id="projectManage">
    <el-row>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>数据管理</el-breadcrumb-item>
        <el-breadcrumb-item>设备状态</el-breadcrumb-item>
      </el-breadcrumb>
      <el-divider></el-divider>
    </el-row>
    <el-row>
      <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle">
        <el-table-column type="index" width="50" />
        <el-table-column prop="device_id" label="设备Id">
        </el-table-column>
        <el-table-column prop="time" label="时间">
        </el-table-column>
        <el-table-column prop="status.air_h" label="湿度">
        </el-table-column>
        <el-table-column prop="status.air_t" label="温度">
        </el-table-column>
        <el-table-column prop="status.bat_p" label="电量（百分比）">
        </el-table-column>
        <el-table-column prop="status.bat_v" label="电压（伏特）">
        </el-table-column>
        <el-table-column prop="status.pm_10" label="PM10">
        </el-table-column>
        <el-table-column prop="status.pm_25" label="PM2.5">
        </el-table-column>
        <el-table-column prop="status.belt_t" label="土工带温度">
        </el-table-column>
        <el-table-column prop="status.traf_f" label="交通流量">
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editFormVisible = true; editForm = scope.row">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-sizes="[5, 10, 20]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </el-row>
    <el-dialog title="设备参数" :visible.sync="editFormVisible">
      <div v-if="loading">请求设备状态中...</div>
      <div v-else>
        <el-form :model="editForm" ref="editForm">
          <el-form-item label="数据上报周期（分钟）" prop="send_p" :rules="[{ required: true, message: '请输入数据上报周期', validator: validateSendP }]">
            <el-input-number v-model="send_p" :min="1" :max="10" controls-position="right" />
          </el-form-item>
          <el-form-item label="MQTT上报地址" prop="mqtt_ip" :disabled="true">
            <el-input v-model="editForm.mqtt_ip" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="MQTT上报端口" prop="mqtt_port" :disabled="true">
            <el-input v-model="editForm.mqtt_port" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">关闭</el-button>
        <el-button type="primary" @click="setSendP" :disabled="loading">设置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import api from '@/api/api'
import * as moment from 'moment';

export default {
  name: 'projectManage',
  components: {
  },
  data() {
    return {
      editFormVisible: false,
      send_p: 0,
      editForm: {
        mqtt_ip: null,
        mqtt_port: null
      },
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      headerCellStyle: {
        background: 'rgb(245,245,245)'
      },
      loading: false,
      tableData: []
    }
  }, mounted() {
    const that = this;
    that.refresh();
    that.moment = moment;
  },
  methods: {
    refresh() {
      const that = this;
      api.post('/distinctedDeviceStatus', { pageSize: that.pageSize, pageIndex: 1 }).then(response => {
        that.totalCount = response.data.totalCount;
        that.tableData = response.data.data.map(data => {
          data.time= that.moment(data.time).format('YYYY-MM-DD HH:mm:ss')
          return data;
        });
      })
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.refresh();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.refresh();
    },
    setSendP() {
      api.post('/writeConfigRequest', { device_id: this.editForm.device_id, send_p: this.send_p }).then(() => {
        this.loading = true;
        this.$message.success(`设置成功，当前上报周期为${this.send_p}分钟`);
        this.loading = false;
        this.editFormVisible = false;
      });
    },
    refreshStatus() {
      this.loading = true;
      api.post('/readConfigRequest', { device_id: this.editForm.device_id }).then(() => {
        this.listenForConfigResponse();
      });
    },
    listenForConfigResponse() {
      if (window.EventSource) {
        // 如果已经存在 EventSource 实例，先关闭它
        if (this.eventSource) {
          this.eventSource.close();
        }
        // 创建新的 EventSource 实例
        this.eventSource = new EventSource('/api/readConfigResponse');
        this.eventSource.onmessage = (event) => {
          const data = JSON.parse(event.data);
          if (data.id === this.editForm.device_id) {
            this.send_p = data.data.send_p;
            this.editForm.mqtt_ip = data.data.mqtt_ip;
            this.editForm.mqtt_port = data.data.mqtt_port;
            this.loading = false;
          }
        };
      } else {
        console.error('Your browser does not support Server-Sent Events.');
      }
    },
    validateSendP(rule, value, callback) {
      if (value < 1 || value > 10) {
        callback(new Error('取值范围1-10'));
      } else {
        callback();
      }
    }
  },
  watch: {
    editFormVisible(newValue) {
      if (newValue) {
        this.refreshStatus();
      }
    }
  }
}
</script>

<style lang="less" scoped>
#projectManage {
  padding: 20px;
}

.buttons {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
}
</style>
